module.exports = __webpack_public_path__ + "img/LOGO 2@2x.bd0202b9.png";